import { APIClient } from '@/infrastructure/network/Gmo/APIClient'

export class GmoGatewayBase {
  apiClient: APIClient

  constructor(apiClient: APIClient) {
    this.apiClient = apiClient
  }
}
